export enum SeturLoyaltyPointTypes {
  SETUR_POINT = 'SeturPoint',
  PURCHASED_POINT = 'PurchasedPoint',
  GIFT_POINT = 'GiftPoint',
  POINT_SPEND_CANCEL = 'PointSpendCancel',
  SPENDING = 'Spending',
  EARNED_POINT_CANCEL = 'EarnedPointCancel',
  COUPON_POINT = 'CouponPoint',
}
